export default __webpack_public_path__ + "ff0dc02e61d49857704bd2ff0937c452.png";